import { createContext } from 'react'
import { AppManager } from '../../lib'

export const AppManagerContext = createContext<AppManager>(null!)
